import { Phone, Mail, MapPin, Clock } from "lucide-react";
import useSiteSettings from "@/hooks/useSiteSettings";

export default function Contact() {
  const { settings } = useSiteSettings();
  const c = settings.contact;

  const items = [
    { icon: Phone, label: "Call us", value: c.phone, note: c.phone_note, testid: "contact-phone" },
    { icon: Mail, label: "Email", value: c.email, note: c.email_note, testid: "contact-email" },
    { icon: MapPin, label: "Where", value: c.address, note: c.address_note, testid: "contact-address" },
    { icon: Clock, label: "Hours", value: c.hours, note: c.hours_note, testid: "contact-hours" },
  ];

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-20 lg:py-28 px-6 lg:px-12 bg-[#F5EBD9]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-14 text-center max-w-2xl mx-auto">
          <div className="font-hand text-2xl text-[#A67F4E] mb-2">say hi</div>
          <h2
            data-testid="contact-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#3D2E1C] leading-[1.05]"
          >
            Got questions?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <div
                key={it.label}
                data-testid={it.testid}
                className="p-6 bg-white border-2 border-[#E9DFCB] hover:border-[#D6B98D] transition-colors rounded-2xl"
              >
                <div className="w-11 h-11 rounded-full bg-[#F5EBD9] flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5 text-[#A67F4E]" strokeWidth={2} />
                </div>
                <div className="text-xs font-bold uppercase tracking-wider text-[#7A6A55] mb-1">
                  {it.label}
                </div>
                <div className="font-serif text-xl text-[#3D2E1C] font-bold leading-tight break-words">
                  {it.value}
                </div>
                {it.note && <div className="mt-2 text-xs text-[#7A6A55]">{it.note}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
